/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TomoQuestionnaire } from '../../models/tomo-questionnaire';

export interface GetTomoquestionnaireId$Plain$Params {
  id: string;
  'api-version'?: string;
}

export function getTomoquestionnaireId$Plain(http: HttpClient, rootUrl: string, params: GetTomoquestionnaireId$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<TomoQuestionnaire>> {
  const rb = new RequestBuilder(rootUrl, getTomoquestionnaireId$Plain.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TomoQuestionnaire>;
    })
  );
}

getTomoquestionnaireId$Plain.PATH = '/tomoQuestionnaire/{id}';
